import React from 'react'
import { Container } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { AlertTitle, Box } from '@mui/material'
import { setUser } from '@sentry/react'

// @fixme: investigate why generated eventID can't be found in Sentry
const SentryErrorBoundaryFallback = ({ error, eventId, userUuid }) => {
  setUser({
    id: userUuid,
    ip_address: '{{auto}}',
  })

  return (
    <Box p={1}>
      <Container fixed>
        <Alert severity="error">
          <AlertTitle style={{ fontWeight: 'bold', fontFamily: 'monospace' }}>
            Unexpected error occurred!
          </AlertTitle>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <code>{error.toString()}</code>
            {/* {eventId && (<code>Error ID: {eventId}</code>)} */}
          </div>
        </Alert>
      </Container>
    </Box>
  )
}

SentryErrorBoundaryFallback.defaultProps = {
  userUuid: null,
}

SentryErrorBoundaryFallback.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string.isRequired,
  }).isRequired,
  eventId: PropTypes.string.isRequired,
  userUuid: PropTypes.string,
}

export default connect(({ auth }) => ({
  userUuid: auth.user?.uuid,
}))(SentryErrorBoundaryFallback)
